import React, { useEffect, useState } from "react";
import * as api from "../api";

export default function AgentDropdown({ value, onChange, disabled }) {
  const [agents, setAgents] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        const data = await api.listAgents();
        setAgents(Array.isArray(data) ? data : []);
        setError("");
      } catch (e) {
        console.error(e);
        setError("Грешка при зареждане на агентите");
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const currentId = typeof value === "string" ? value : (value?.id || "");

  return (
    <div className="space-y-1 w-full">
      <div className="relative">
        <select
          className="bg-[#121825] border border-[#1f2638] rounded-xl px-3 py-2 text-sm text-white outline-none 
                     focus:ring-2 focus:ring-violet-600/40 w-full"
          value={currentId}
          onChange={(e) => {
            if (disabled) return;

            const id = e.target.value;
            const selected = agents.find(a => a.id === id);
            onChange?.(
              selected
                ? { id: selected.id, name: selected.name }
                : { id: "", name: "" }
            );
          }}
          disabled={loading || disabled}
        >
          <option value="">
            {loading ? "Зареждане…" : "Изберете агент"}
          </option>
          {agents.map(a => (
            <option key={a.id} value={a.id}>{a.name}</option>
          ))}
        </select>

        {error && <p className="text-xs text-rose-400 mt-1">{error}</p>}
      </div>
    </div>
  );
}
